export default (params) => ({
  trigger: {
    name: 'content_blocks.table.select_navigation',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      redirect: {
        type: 'string',
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_navigation',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
